
import Axios from 'axios';
import { GET_DASHBOARD_GRID_DATA_URL, GET_DASHBOARD_GRID_DOWNLOAD_DATA_URL, GET_DASHBOARD_REPORT_DATA_URL, GET_DASHBOARD_USER_DATA_URL, GET_DEVICE_DETAILS, LOGIN_URL, PERMISSION_URL, REFRESH_TOKEN_URL, SESSION_LOGOUT } from './../../api/index';
import axiosInstance from '../../axiosInstance';
import { BACKEND_URL } from './../../axiosInstance';



export const loginUser = (props) => onResponse => {
    try {
        axiosInstance.post(LOGIN_URL, props.formData)
            .then((response) => {
                onResponse(response?.data ? response?.data : response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getDashboardUserData = () => onResponse => {
    try {
        axiosInstance.get(GET_DASHBOARD_USER_DATA_URL)
            .then((response) => {
                onResponse(response?.data ? response?.data : response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getDashboardGridData = (props) => onResponse => {
    let base_url= GET_DASHBOARD_GRID_DATA_URL;
    if(props?.type && props?.type != '')
    base_url = base_url + '?shift='+ props?.type
    try {
        axiosInstance.get(base_url)
            .then((response) => {
                onResponse(response?.data ? response?.data : response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getDashboardReportData = (partnerid) => onResponse => {
    
const partnerId = Array.isArray(partnerid)
  ? partnerid.map((li) => li?.value)
  : partnerid
  ? [partnerid.value]
  : [];
    try {
        axiosInstance.get(GET_DASHBOARD_REPORT_DATA_URL, {
        params: { partners: partnerId?.join(',') }})
            .then((response) => {
                onResponse(response?.data ? response?.data : response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getDeviceDetails = (firebaseToken, device, device_details) => onResponse => {
    try {
        axiosInstance.post(GET_DEVICE_DETAILS, { firebaseToken, device, device_details })
            .then((response) => {
                onResponse(response?.data ? response?.data : response);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const refreshToken = (refresh_token) => onResponse => {
    try {
        Axios.post(BACKEND_URL + REFRESH_TOKEN_URL, { refresh: refresh_token })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};
export const getAllPermissions = (id = "") => onResponse => {
    try {
        axiosInstance.post(PERMISSION_URL, { group: id })
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const logooutSession = (refresh, comment) => onResponse => {
    try {
        axiosInstance.post(SESSION_LOGOUT, { refresh, comment })
            .then((response) => {
                onResponse(response?.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getDashboardGridDataDownload =  (props,selectpartner)=> async(onResponse) => {
  const partnerId = Array.isArray(selectpartner)
  ? selectpartner.map((li) => li?.value)
  : selectpartner
  ? [selectpartner.value]
  : [];
    try {
        let base_url = GET_DASHBOARD_GRID_DOWNLOAD_DATA_URL;
        const queryParams = new URLSearchParams();

        if (props?.clients?.length > 0) queryParams.append("clients", props?.clients?.map(i=>i.value)?.join(","));
        if (props?.facilities?.length > 0) queryParams.append("facilities", props?.facilities?.map(i=>i.value)?.join(","));
        if (props?.start_date) queryParams.append("start_date", props?.start_date);
        if (props?.end_date) queryParams.append("end_date", props?.end_date);
 if (partnerId.length>0) queryParams.append("partners", partnerId);
       
        const final_url = `${base_url}?${queryParams.toString()}`;
        console.log(final_url)
        axiosInstance.get(final_url)
        .then((response) => {
            onResponse(response?.data);
        })
        .catch((err) => {
            onResponse(err);
        });
    } catch (error) {
        console.error("Error fetching dashboard data:", error);
        onResponse(error);
    }
};